module.exports = __webpack_public_path__ + "static/media/20.d65d5d60.jpg";